import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const topics = [{
  title: 'Nivel de caos mental:',
  desc: 'Evaluación de saturación y entorno.'
}, {
  title: 'Dependencia emocional:',
  desc: 'Desconexión de la validación externa.'
}, {
  title: 'Control de pensamientos:',
  desc: 'Herramientas contra la rumiación.'
}, {
  title: 'Responsabilidad radical:',
  desc: 'Adiós a la victimización silenciosa.'
}, {
  title: 'Eliminación de estímulos tóxicos:',
  desc: 'Desintoxicación digital y ambiental.'
}, {
  title: 'Rutina de estabilidad:',
  desc: 'Pasos minimalistas para tus mañanas y noches.'
}];
export function SystemOverview() {
  return <section className="py-24 px-6 border-b border-ink/10" data-id="element-139">
      <div className="max-w-editorial mx-auto" data-id="element-140">
        <SectionHeader number="04" title="🧠 EL SISTEMA N°1 PARA DESMANTELAR EL CAOS" data-id="element-141" />

        <div className="max-w-3xl mb-12" data-id="element-142">
          <h3 className="text-2xl font-serif text-ink mb-4" data-id="element-143">
            Estructura del Tomo 1 — Nivel Inicial a Avanzado — Todo Resuelto.
          </h3>
          <p className="text-lg text-ink-light font-sans" data-id="element-144">
            Un método directo al grano que funciona desde hoy en tu casa, tu
            oficina o tu rutina diaria.
          </p>
        </div>

        <div className="bg-bone-dark/50 border border-ink/10 p-8 md:p-12 rounded-sm" data-id="element-145">
          <h4 className="text-xl font-serif text-ink mb-8 flex items-center gap-3" data-id="element-146">
            <Brain size={24} className="text-oxblood" data-id="element-147" />
            Ejes temáticos incluidos:
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-148">
            {topics.map((topic, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex gap-4" data-id="element-149">
                <span className="font-serif text-oxblood text-lg font-medium w-6 shrink-0" data-id="element-150">
                  {index + 1}.
                </span>
                <p className="text-ink-light font-sans leading-relaxed" data-id="element-151">
                  <strong className="text-ink font-medium" data-id="element-152">
                    {topic.title}
                  </strong>{' '}
                  {topic.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}